import { Navigate } from 'react-router-dom';
import React from 'react';

import { useKeycloak } from '@App/settings/keycloak';
import { LayoutWithSidebar } from './LayoutWithSidenav';


type Props = {
  roles: string[];
  children?: React.ReactNode | React.ReactNode[] | JSX.Element | JSX.Element[];
};

export const ProtectedWithSidebar: React.FC<Props> = ({roles, ...rest}) => {
  const { authenticated, keycloak } = useKeycloak();

  const isAuthorized = () => {
    if (authenticated && roles) {
      return roles.some((role) => {
        const realm = keycloak?.hasRealmRole(role);
        const resource = keycloak?.hasResourceRole(role);
        const ldapGroups = keycloak?.tokenParsed?.['groups'] as string[] | undefined ?? [];
        const hasPermission = ldapGroups.includes(role);
        
        return realm || resource || hasPermission;
      });
    }

    return false;
  };

  return isAuthorized() ? <LayoutWithSidebar {...rest} /> : <Navigate to={"/unauthorized"} replace />;
};
